<template>
  <section>
    <div v-if="$route.params.form == undefined" class="container">
      <div class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p01.jpg')">

        </div>
        <div class="title">
          Rendszeres szociális támogatás és költségtérítés mérséklés
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete: <span>{{hataridok.SzocKerelemKitoltesKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete elsősöknek: <span>{{hataridok.SzocKerelemKitoltesKezdeteElsos}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának határideje: <span>{{hataridok.SzocKerelemKitoltesVege}}</span>
            </li>
          </ul>
          <div style="padding-bottom: 25px;" class="navbar">
            <button v-if="!RendszeresSzocialisTamogatasGombDisable" :disabled="RendszeresSzocialisTamogatasGombDisable" v-on:click="palyazasClick('rendszeres_szocialis_tamogatas')" type="button" class="button">Pályázás</button>

            <button v-if="urlapKitoltveHatar('RendszeresSzocialisTamogatas')" v-on:click="rendszeresSzocialisTamogatasPdf" type="button" class="button">Pályázat letöltése</button>

            <button v-if="urlapKitoltveHatar('RendszeresSzocialisTamogatas')" v-on:click="rendszeresSzocialisTamogatasBiralatPontok" type="button" class="button">Pontszámok</button>

            <ul class="list">
              <li v-html="RendszeresSzocialisTamogatasStatusz"></li>
            </ul>
          </div>
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Reklamációs határidő: <span>{{hataridok.SzocKerelemReklamacioVege}}</span>
            </li>
          </ul>
          <div style="padding-bottom: 25px;" class="navbar">
            <button :disabled="RendszeresSzocialisReklamacioGombDisable" v-on:click="palyazasClick('rendszeres_szocialis_reklamacio')" type="button" class="button">Reklamáció</button>
            <ul class="list">
              <li v-html="RendszeresSzocialisReklamacioStatusz"></li>
            </ul>
          </div>
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Korrekciós kérelem beadásának kezdete: <span>{{hataridok.SzocKerelemKorrekcioKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Korrekciós kérelem beadásának vége: <span>{{hataridok.SzocKerelemKorrekcioVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="RendszeresSzocialisKorrekciosKerelemGombDisable" v-on:click="palyazasClick('korrekcios_kerelem')" type="button" class="button">Korrekció</button>
            <ul class="list">
              <li v-html="RendszeresSzocialisKorrekciosKerelemStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p02.jpg')">

        </div>
        <div class="title">
          Kiemelkedő sport tevékenység támogatása
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának határideje: <span>{{hataridok.KiemelkedoKitoltesVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="KiemelkedoSportTamogatasGombDisable" v-on:click="palyazasClick('kiemelkedo_sport_tamogatas')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="KiemelkedoSportTamogatasStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p04.jpg')">

        </div>
        <div class="title">
          Kiemelkedő tudományos, kulturális pályázat
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának határideje: <span>{{hataridok.KiemelkedoKitoltesVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="KiemelkedoTudomanyosKulturalisTamogatasGombDisable" v-on:click="palyazasClick('kiemelkedo_tudomanyos_kulturalis_tamogatas')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="KiemelkedoTudomanyosKulturalisTamogatasStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p03.jpg')">

        </div>
        <div class="title">
          Rendkívüli szociális ösztöndíj
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete: <span>{{hataridok.SzocKerelemKitoltesKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának vége: <span>{{hataridok.RendkivuliKitoltesVege}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              <span>Minden hónap 20-ig</span> beérkezett pályázatok kerülnek elbírálásra a következő hónapra
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Januárban és júniusban nem lehet beadni
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="RendkivuliSzocialisTamogatasGombDisable" v-on:click="palyazasClick('rendkivuli_szocialis_tamogatas')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="RendkivuliSzocialisTamogatasStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p07.jpg')">

        </div>
        <div class="title">
          Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete: <span>{{hataridok.KulfoldiUtikoltsegPalyazatKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának határideje: <span>{{hataridok.KulfoldiUtikoltsegPalyazatVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="KulfoldiUtikoltsegPalyazatGombDisable" v-on:click="palyazasClick('kulfoldi_utikoltseg_palyazat')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="KulfoldiUtikoltsegPalyazatStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="hokTag" class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p05.jpg')">

        </div>
        <div class="title">
          HÖK és Hallgatói Szervezetek kulturális rendezvényeinek támogatása
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete: <span>{{ktr_hataridok.HokKultKitoltesKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának határideje: <span>{{ktr_hataridok.HokKultKitoltesVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="RendezvenySzervezesTamogatasiPalyazatGombDisable" v-on:click="palyazasClick('rendezveny_szervezes_tamogatasi_palyazat')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="RendezvenySzervezesTamogatasiPalyazatStatusz"></li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="hokTag" class="competition-item-hatar">
        <div class="image" style="background-image: url('assets/img/p06.jpg')">

        </div>
        <div class="title">
          Tanulmányi kirándulás támogatása
        </div>
        <div class="content">
          <ul class="list">
            <li>
              <i class="fa fa-info-circle"></i>
              Pályázat beadásának kezdete: <span>{{ktr_hataridok.TankirKitoltesKezdete}}</span>
            </li>
            <li>
              <i class="fa fa-info-cirScle"></i>
              Pályázat beadásának határideje: <span>{{ktr_hataridok.TankirKitoltesVege}}</span>
            </li>
          </ul>
          <div class="navbar">
            <button :disabled="TanulmanyiKirandulasPalyazatGombDisable" v-on:click="palyazasClick('tanulmanyi_kirandulas_palyazat')" type="button" class="button">Pályázás</button>
            <ul class="list">
              <li v-html="TanulmanyiKirandulasPalyazatStatusz"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <RendkivuliSzocialisTamogatas v-if="$route.params.form != undefined && $route.params.form == 'rendkivuli_szocialis_tamogatas'"/>
    <RendszeresSzocialisTamogatas v-if="$route.params.form != undefined && $route.params.form == 'rendszeres_szocialis_tamogatas'"/>
    <KiemelkedoSportTamogatas v-if="$route.params.form != undefined && $route.params.form == 'kiemelkedo_sport_tamogatas'"/>
    <KiemelkedoTudomanyosKulturalisTamogatas v-if="$route.params.form != undefined && $route.params.form == 'kiemelkedo_tudomanyos_kulturalis_tamogatas'"/>
    <KulfoldiUtikoltsegPalyazat v-if="$route.params.form != undefined && $route.params.form == 'kulfoldi_utikoltseg_palyazat'"/>
    <RendezvenySzervezesTamogatasiPalyazat v-if="$route.params.form != undefined && $route.params.form == 'rendezveny_szervezes_tamogatasi_palyazat' && hokTag"/>
    <TanulmanyiKirandulasPalyazat v-if="$route.params.form != undefined && $route.params.form == 'tanulmanyi_kirandulas_palyazat' && hokTag"/>
    <KorrekciosKerelem v-if="$route.params.form != undefined && $route.params.form == 'korrekcios_kerelem'"/>
    <RendszeresSzocialisReklamacio v-if="$route.params.form != undefined && $route.params.form == 'rendszeres_szocialis_reklamacio'"/>
    <RendszeresSzocialisPontok v-if="szocialisPontokPopup" v-on:onClose="szocialisPontokPopup = false;"/>
  </section>
</template>
<script>
import Vue from 'vue';
import RendkivuliSzocialisTamogatas from './rendkivuli_szocialis_tamogatas.vue';
import RendszeresSzocialisTamogatas from './rendszeres_szocialis_tamogatas.vue';
import KiemelkedoSportTamogatas from './kiemelkedo_sport_tamogatas.vue';
import KiemelkedoTudomanyosKulturalisTamogatas from './kiemelkedo_tudomanyos_kulturalis_tamogatas.vue';
import KulfoldiUtikoltsegPalyazat from './kulfoldi_utikoltseg_palyazat.vue';
import RendezvenySzervezesTamogatasiPalyazat from './rendezveny_szervezes_tamogatasi_palyazat.vue';
import TanulmanyiKirandulasPalyazat from './tanulmanyi_kirandulas_palyazat.vue';
import KorrekciosKerelem from './korrekcios_kerelem.vue';
import RendszeresSzocialisReklamacio from './rendszeres_szocialis_reklamacio.vue';
import RendszeresSzocialisPontok from './rendszeres_szocialis_pontok.vue';

export default {
  components: {
    RendkivuliSzocialisTamogatas,
    RendszeresSzocialisTamogatas,
    KiemelkedoSportTamogatas,
    KiemelkedoTudomanyosKulturalisTamogatas,
    KulfoldiUtikoltsegPalyazat,
    RendezvenySzervezesTamogatasiPalyazat,
    TanulmanyiKirandulasPalyazat,
    KorrekciosKerelem,
    RendszeresSzocialisReklamacio,
    RendszeresSzocialisPontok
  },
  props: ['page'],
  data: function() {
    return {
      hataridok: [],
      ktr_hataridok: [],
      hokTag: true,
      hatar_kitoltes: [],
      ktr_kitoltes: [],
      szocialisPontokPopup: false
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });

      _this.getHataridok();
      //_this.felhasznaloHOKTag();
      _this.kitoltesStatusz();
    });
  },
  watch: {
    '$route': function() {
      this.kitoltesStatusz();
    }
  },
  computed: {
    RendszeresSzocialisTamogatasGombDisable: function() {
      return !this.urlapKitolthetoHatar('RendszeresSzocialisTamogatas');
    },

    KiemelkedoSportTamogatasGombDisable: function() {
      return !this.urlapKitolthetoHatar('KiemelkedoSportTamogatas');
    },

    KiemelkedoTudomanyosKulturalisTamogatasGombDisable: function() {
      return !this.urlapKitolthetoHatar('KiemelkedoTudomanyosKulturalisTamogatas');
    },

    RendkivuliSzocialisTamogatasGombDisable: function() {
      return !this.urlapKitolthetoHatar('RendkivuliSzocialisTamogatas');
    },

    KulfoldiUtikoltsegPalyazatGombDisable: function() {
      return !this.urlapKitolthetoHatar('KulfoldiUtikoltsegPalyazat');
    },

    RendszeresSzocialisReklamacioGombDisable: function() {
      return !this.urlapKitolthetoHatar('RendszeresSzocialisReklamacio');
    },

    RendszeresSzocialisKorrekciosKerelemGombDisable: function() {
      return !this.urlapKitolthetoHatar('RendszeresSzocialisKorrekciosKerelem');
    },

    RendezvenySzervezesTamogatasiPalyazatGombDisable: function() {
      return !this.urlapKitolthetoKTR('RendezvenySzervezesPalyazat');
    },

    TanulmanyiKirandulasPalyazatGombDisable: function() {
      return !this.urlapKitolthetoKTR('TanulmanyiKirandulasPalyazat');
    },

    RendszeresSzocialisTamogatasStatusz: function() {
      if (this.urlapKitolthetoHatar('RendszeresSzocialisTamogatas')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    RendszeresSzocialisReklamacioStatusz: function() {
      if (this.urlapKitolthetoHatar('RendszeresSzocialisReklamacio')) {
        return '<i class="fa fa-check-circle-o"></i>Reklamáció: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Reklamáció: <span>Nem adható be</span>';
      }
    },

    RendszeresSzocialisKorrekciosKerelemStatusz: function() {
      if (this.urlapKitolthetoHatar('RendszeresSzocialisKorrekciosKerelem')) {
        return '<i class="fa fa-check-circle-o"></i>Korrekciós kérelem: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Korrekciós kérelem: <span>Nem adható be</span>';
      }
    },

    KiemelkedoSportTamogatasStatusz: function() {
      if (this.urlapKitolthetoHatar('KiemelkedoSportTamogatas')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    KiemelkedoTudomanyosKulturalisTamogatasStatusz: function() {
      if (this.urlapKitolthetoHatar('KiemelkedoTudomanyosKulturalisTamogatas')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    RendkivuliSzocialisTamogatasStatusz: function() {
      if (this.urlapKitolthetoHatar('RendkivuliSzocialisTamogatas')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    KulfoldiUtikoltsegPalyazatStatusz: function() {
      if (this.urlapKitolthetoHatar('KulfoldiUtikoltsegPalyazat')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    RendezvenySzervezesTamogatasiPalyazatStatusz: function() {
      if (this.urlapKitolthetoKTR('RendezvenySzervezesPalyazat')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },

    TanulmanyiKirandulasPalyazatStatusz: function() {
      if (this.urlapKitolthetoKTR('TanulmanyiKirandulasPalyazat')) {
        return '<i class="fa fa-check-circle-o"></i>Pályázat: <span>Beadható</span>';
      } else {
        return '<i class="fa fa-ban"></i>Pályázat: <span>Nem adható be</span>';
      }
    },
  },
  methods: {
    urlapKitolthetoKTR: function(urlap) {
      var r = false;

      this.ktr_kitoltes.map(function(k) {
        if (k.urlap == urlap) {
          r = k.kitoltheto;
        }
      });

      return r;
    },

    urlapKitolthetoHatar: function(urlap) {
      var r = false;

      this.hatar_kitoltes.map(function(hk) {
        if (hk.urlap == urlap) {
          r = hk.kitoltheto;
        }
      });

      return r;
    },

    urlapKitoltveHatar: function(urlap) {
      var r = false;

      if (this.hatar_kitoltes.length > 0) {
        this.hatar_kitoltes.map(function(hk) {
          if (hk.urlap == urlap && hk.kitoltve != undefined && hk.kitoltve) {
            r = true;
          }
        });
      }

      return r;
    },

    palyazasClick: function(form) {
      this.$router.push({
        path: 'tamogatas/'+form
      });
      window.scrollTo(0,0);
    },

    felhasznaloHOKTag: function() {
      var _this = this;

      this.$root.ajax('form/felhasznaloHOKTag/' + this.$root.user.id, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.hokTag = response.tage;

          } else {
            swal('Hiba!',response.error,'error');
          }
        }
      });
    },

    kitoltesStatusz: function() {
      var _this = this;

      this.$root.ajax('hatar/kitoltesStatusz/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.hatar_kitoltes = response.hatar_kitoltes;
            _this.hatarUrlapKitoltve('RendszeresSzocialisTamogatas');
          } else {
            swal('Hiba!',response.error,'error');
          }
        }
      });

      this.$root.ajax('form/kitoltesStatusz/' + this.$root.user.id, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.ktr_kitoltes = response.ktr_kitoltes;

          } else {
            swal('Hiba!',response.error,'error');
          }
        }
      });
    },

    getHataridok: function() {
      var _this = this;
      this.$root.ajax('hatar/hataridok/', {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.hataridok = response.hataridok;
            _this.ktr_hataridok = response.ktr_hataridok;
          } else
            swal('Hiba!',response.error,'error');
        }
      });
    },

    hatarUrlapKitoltve: function(urlap) {
      var _this = this;

      this.$root.ajax('hatar/urlap_kitoltve/' + urlap + '/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.hatar_kitoltes.map(function(hk) {
              if (hk.urlap == urlap)
                Vue.set(hk, 'kitoltve', response.kitoltve);
            });
          } else
            swal('Hiba!',response.error,'error');
        }
      });
    },

    rendszeresSzocialisTamogatasPdf: function() {
      var _this = this;
      this.$root.ajax('hatar/rendszeres_szocialis_tamogatas_pdf/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            window.open('assets/urlap_kitoltesek/' + response.filename + '?' + Math.random(100000));
          } else {
            swal('Hiba!',response.error,'error');
          }
        }
      });
    },

    rendszeresSzocialisTamogatasBiralatPontok: function() {
      this.szocialisPontokPopup = true;
    }
  }
}

</script>



// WEBPACK FOOTER //
// hatar.vue?1820c189